import styled from 'styled-components';

import { MOBILE_PADDING, PAGE_WIDTH } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Section = styled.section`
  margin: 0 auto;
  max-width: ${PAGE_WIDTH}px;
  padding: ${MOBILE_PADDING}px;
  padding-bottom: 65px;
  position: relative;
  width: 100%;

  ${media.tabletL`
    padding: 0;
  `};
`;

export const SectionInner = styled.div`
  width: 100%;

  ${media.tabletL`
    align-items: center;
    display: flex;
    flex-direction: row-reverse;
    padding: 100px 80px;
  `};
`;

export const ImageContainer = styled.div`
  flex-shrink: 0;
  width: 100%;

  ${media.tabletL`
    width: calc(50% - 40px);
  `};
`;

export const ContentContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;

  ${media.tabletL`
    align-items: center;
    flex-grow: 1;
    justify-content: center;
    text-align: left;
    width: calc(50% - 40px);
  `};
`;

export const Title = styled.h1`
  font-size: 30px;
  letter-spacing: 1px;
  margin: 35px 0 0 0;
  max-width: 400px;
  text-transform: uppercase;
  width: 100%;

  > span {
    font-weight: 600;
  }

  ${media.tabletL`
    font-size: 44px;
    margin-top: 0;
  `};

  ${media.desktop`
    font-size: 54px;
  `};
`;

export const Text = styled.p`
  font-size: 16px;
  font-weight: 600;
  margin: 15px 0 0 0;
  max-width: 400px;
  width: 100%;

  ${media.desktop`
    margin: 20px 0 0 0;
    font-size: 18px;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/InspirationPage/InspirationOverview/InspirationOverview.style.js